module.exports = __webpack_public_path__ + "static/img/img-background-422.0fb08ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-422.png
// module id = kK79
// module chunks = 36